import { SelectCamera } from "./select-camera";
import { SelectMicrophone } from "./select-microphone";
import { SelectSpeaker } from "./select-speaker";

export function SelectDevice() {
  return (
    <div className="grid grid-cols-3 gap-2">
      <SelectCamera />
      <SelectMicrophone />
      <SelectSpeaker />
    </div>
  );
}
